var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_16208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.40371 6.79004C7.26461 6.79004 6.34121 7.71344 6.34121 8.85254C6.34121 9.99164 7.26461 10.915 8.40371 10.915C9.54281 10.915 10.4662 9.99164 10.4662 8.85254C10.4662 7.71344 9.54238 6.79004 8.40371 6.79004ZM21.0838 3.00879H4.58379C3.10352 3.00879 1.87207 4.23984 1.87207 5.75879V19.5088C1.87207 21.0277 3.10312 22.2588 4.5834 22.2588H21.0834C22.6023 22.2588 23.8334 21.0277 23.8334 19.5088V5.75879C23.8338 4.23984 22.6393 3.00879 21.0838 3.00879ZM21.7713 19.2209L15.8932 11.233C15.7857 11.0354 15.5408 10.915 15.2787 10.915C15.016 10.915 14.7708 11.034 14.6252 11.2321L10.0447 17.4239L8.45098 15.443C8.30312 15.2592 8.06709 15.1505 7.81633 15.1505C7.5653 15.1505 7.32949 15.2591 7.18125 15.443L3.93625 19.4739C3.93625 19.4727 3.93625 19.4752 3.93625 19.4739L3.93453 5.75879C3.93453 5.37972 4.24296 5.07129 4.62203 5.07129H21.122C21.5011 5.07129 21.8095 5.37972 21.8095 5.75879V19.2209H21.7713Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_16208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(1.87256 1.63379)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageField);
export default __webpack_public_path__ + "static/media/image-field.05b7646b81d926a0b814e5b2ee92550c.svg";
export { ForwardRef as ReactComponent };